/**
 * Slider 3D Imersivo
 * Version: 5.1 (Hehku Native Cart + Sync Colors Restaurado)
 */

(function() {
  'use strict';

  const SELECTORS = {
    section: '.slider3d',
    bg: '.slider3d__bg',
    gradient: '.slider3d__gradient',
    particles: '.slider3d__particles',
    nav: '.slider3d__nav',
    pill: '.slider3d__nav-pill',
    navBtn: '.slider3d__nav-btn',
    container: '.slider3d__container',
    slide: '.slider3d__slide',
    imageWrap: '.slider3d__image-wrap',
    imageLink: '.slider3d__image-link',
    image: '.slider3d__image',
    btn: '.slider3d__btn',
    arrowPrev: '.slider3d__arrow--prev',
    arrowNext: '.slider3d__arrow--next'
  };

  const CLASSES = {
    visible: 'is-visible',
    active: 'is-active',
    prev: 'is-prev',
    next: 'is-next',
    hidden: 'is-hidden',
    animating: 'is-animating',
    dragging: 'is-dragging',
    loading: 'is-loading'
  };

  // --- CONFIGURAÇÕES DE TRANSIÇÃO DE COR (Mantido do seu código) ---
  const SYNC_DURATION = 800; // ms
  const SYNC_EASING = 'cubic-bezier(0.25, 1, 0.5, 1)';
  const SYNC_TRANSITION = `background-color ${SYNC_DURATION}ms ${SYNC_EASING}, fill ${SYNC_DURATION}ms ${SYNC_EASING}`;

  // IDs fixos dos dividers (Mantido do seu código)
  const TOP_DIVIDER_ID = 'template--18220740706417__divider_Dbap8X';
  const BOTTOM_DIVIDER_ID = 'template--18220740706417__divider_AeLKGJ';

  class Slider3D {
    constructor(section) {
      this.section = section;
      this.bg = section.querySelector(SELECTORS.bg);
      this.gradient = section.querySelector(SELECTORS.gradient);
      this.particlesContainer = section.querySelector(SELECTORS.particles);
      this.nav = section.querySelector(SELECTORS.nav);
      this.pill = section.querySelector(SELECTORS.pill);
      this.container = section.querySelector(SELECTORS.container);
      this.slides = Array.from(section.querySelectorAll(SELECTORS.slide));
      this.navButtons = Array.from(section.querySelectorAll(SELECTORS.navBtn));
      this.arrowPrev = section.querySelector(SELECTORS.arrowPrev);
      this.arrowNext = section.querySelector(SELECTORS.arrowNext);

      this.currentIndex = 0;
      this.currentMenuIndex = 0;
      this.currentCategory = '';
      this.visibleSlides = [];
      this.categories = [];
      
      // Estados de Interação
      this.isDragging = false;
      this.isScrolling = false;
      this.isIntentChecked = false;
      this.dragStartX = 0;
      this.dragStartY = 0;
      this.dragCurrentX = 0;
      this.dragOffset = 0;
      this.parallaxEnabled = section.dataset.parallax === 'true';

      // Sync state (Mantido)
      this.syncTimeout = null;
      this.lastSyncColor = null;

      // Cache dos elementos dos dividers (Mantido)
      this.topDividerPath = null;
      this.bottomDividerPath = null;
      this.cacheDividerElements();

      this.init();
    }

    // --- LÓGICA DE CACHE DE DIVIDERS (Mantido) ---
    cacheDividerElements() {
      const topDivider = document.getElementById(TOP_DIVIDER_ID);
      if (topDivider) {
        const paths = topDivider.querySelectorAll('path');
        if (paths.length > 0) {
          this.topDividerPath = paths[paths.length - 1];
        }
      }

      const bottomDivider = document.getElementById(BOTTOM_DIVIDER_ID);
      if (bottomDivider) {
        const paths = bottomDivider.querySelectorAll('path');
        if (paths[2]) {
          this.bottomDividerPath = paths[2];
        }
      }
    }

    init() {
      this.navButtons.forEach(btn => {
        this.categories.push(btn.dataset.category);
      });

      this.updateMenuPositions();

      if (this.navButtons.length > 0) {
        this.currentCategory = this.navButtons[0].dataset.category;
        this.filterByCategory(this.currentCategory);
      } else {
        this.visibleSlides = this.slides;
        this.slides.forEach(s => s.classList.add(CLASSES.visible));
        this.updateSlides();
      }

      this.initParticles();
      this.bindEvents();
    }

    // =========================================================
    // PARTICLES
    // =========================================================
    initParticles() {
      if (!this.particlesContainer) return;
      const count = parseInt(this.section.dataset.particleCount) || 20;
      this.particlesContainer.innerHTML = '';
      for (let i = 0; i < count; i++) {
        this.createParticle();
      }
    }

    createParticle() {
      const particle = document.createElement('div');
      particle.className = 'slider3d__particle';
      const size = Math.random() * 8 + 4;
      const left = Math.random() * 100;
      const duration = Math.random() * 15 + 10;
      const delay = Math.random() * 10;
      const opacity = Math.random() * 0.4 + 0.2;
      particle.style.cssText = `width: ${size}px; height: ${size}px; left: ${left}%; background: rgba(255, 255, 255, ${opacity}); animation-duration: ${duration}s; animation-delay: ${delay}s; --particle-opacity: ${opacity};`;
      this.particlesContainer.appendChild(particle);
    }

    // =========================================================
    // PARALLAX (Versão Suave / Anti-Jitter)
    // =========================================================
    handleParallax(e) {
      if (!this.parallaxEnabled) return;

      const activeSlide = this.visibleSlides[this.currentIndex];
      if (!activeSlide) return;

      const imageLink = activeSlide.querySelector(SELECTORS.imageLink);
      if (!imageLink) return;

      // Remove transição para movimento instantâneo
      imageLink.style.transition = 'none';

      const rect = this.section.getBoundingClientRect();
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      
      const rotateY = ((mouseX - centerX) / centerX) * 8;
      const rotateX = ((centerY - mouseY) / centerY) * 8;
      const translateX = ((mouseX - centerX) / centerX) * 12;
      const translateY = ((mouseY - centerY) / centerY) * 12;

      requestAnimationFrame(() => {
        imageLink.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateX(${translateX}px) translateY(${translateY}px)`;
      });
    }

    resetParallax() {
      // Restaura transição para voltar suave
      this.slides.forEach(slide => {
        const imageLink = slide.querySelector(SELECTORS.imageLink);
        if (imageLink) {
          imageLink.style.transition = 'transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)';
          imageLink.style.transform = '';
        }
      });
    }

    // =========================================================
    // DRAG / SWIPE
    // =========================================================
    handleDragStart(e) {
      if (this.visibleSlides.length <= 1) return;
      this.isDragging = true;
      this.isScrolling = false;
      this.isIntentChecked = false;
      this.dragStartX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      this.dragStartY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
      this.dragCurrentX = this.dragStartX;
      this.dragOffset = 0;
    }

    handleDragMove(e) {
      if (!this.isDragging || this.isScrolling) return;
      const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      const clientY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;

      if (!this.isIntentChecked && e.type.includes('touch')) {
        const diffX = Math.abs(clientX - this.dragStartX);
        const diffY = Math.abs(clientY - this.dragStartY);
        if (diffX < 5 && diffY < 5) return;
        this.isIntentChecked = true;
        if (diffY > diffX) {
          this.isScrolling = true;
          this.isDragging = false;
          return;
        }
        if (e.cancelable) e.preventDefault();
      } else {
        if (e.cancelable && !this.isScrolling) e.preventDefault();
      }

      this.visibleSlides.forEach(slide => slide.classList.add(CLASSES.dragging));
      this.section.style.cursor = 'grabbing';
      this.dragCurrentX = clientX;
      this.dragOffset = this.dragCurrentX - this.dragStartX;
      
      const maxDrag = this.section.offsetWidth * 0.4;
      if (Math.abs(this.dragOffset) > maxDrag) {
         const extra = Math.abs(this.dragOffset) - maxDrag;
         const resistedExtra = extra * 0.2;
         this.dragOffset = this.dragOffset > 0 ? maxDrag + resistedExtra : -(maxDrag + resistedExtra);
      }
      this.section.style.setProperty('--drag-offset', `${this.dragOffset}px`);
    }

    handleDragEnd() {
      this.isDragging = false;
      this.isScrolling = false;
      this.isIntentChecked = false;
      this.visibleSlides.forEach(slide => slide.classList.remove(CLASSES.dragging));
      this.section.style.cursor = '';
      const threshold = this.section.offsetWidth * 0.15;
      if (this.dragOffset < -threshold) {
        this.navigate('next');
      } else if (this.dragOffset > threshold) {
        this.navigate('prev');
      }
      this.section.style.setProperty('--drag-offset', '0px');
      this.dragOffset = 0;
    }

    // =========================================================
    // NAVIGATION & SYNC
    // =========================================================
    goToCategory(category, index) {
      if (this.currentMenuIndex !== index) this.triggerJellyAnimation();
      this.currentMenuIndex = index;
      this.updateMenuPositions();
      this.currentCategory = category;
      this.currentIndex = 0;
      this.filterByCategory(category);
    }

    filterByCategory(category) {
      this.slides.forEach(slide => {
        slide.classList.remove(CLASSES.visible, CLASSES.active, CLASSES.prev, CLASSES.next);
        if (slide.dataset.category === category) slide.classList.add(CLASSES.visible);
      });
      this.visibleSlides = this.slides.filter(s => s.classList.contains(CLASSES.visible));
      this.updateSlides();
    }

    updateSlides() {
      if (this.visibleSlides.length === 0) return;
      this.resetParallax();
      this.visibleSlides.forEach(slide => {
        slide.classList.remove(CLASSES.active, CLASSES.prev, CLASSES.next);
      });
      const total = this.visibleSlides.length;
      const prevIndex = (this.currentIndex - 1 + total) % total;
      const nextIndex = (this.currentIndex + 1) % total;
      
      const activeSlide = this.visibleSlides[this.currentIndex];
      activeSlide.classList.add(CLASSES.active);
      
      if (total > 1) {
        this.visibleSlides[prevIndex].classList.add(CLASSES.prev);
        this.visibleSlides[nextIndex].classList.add(CLASSES.next);
      }
      
      // RESTAURADO: Sincronização avançada de cores (Fundo + Dividers)
      const bgColor = activeSlide.dataset.bg;
      this.syncAllBackgrounds(bgColor);

      if (this.nav && activeSlide.dataset.menuText) {
        this.nav.style.setProperty('--menu-text', activeSlide.dataset.menuText);
      }
    }

    // =========================================================
    // LÓGICA DE COR (FUNDO + DIVIDERS) - Mantido
    // =========================================================
    syncAllBackgrounds(color) {
      if (!color) return;

      if (this.lastSyncColor === color) return;
      this.lastSyncColor = color;

      if (this.syncTimeout) {
        clearTimeout(this.syncTimeout);
        this.syncTimeout = null;
      }

      const elements = [];

      if (this.bg) {
        elements.push({ el: this.bg, prop: 'backgroundColor' });
      }

      if (this.topDividerPath) {
        elements.push({ el: this.topDividerPath, prop: 'fill' });
      }

      if (this.bottomDividerPath) {
        elements.push({ el: this.bottomDividerPath, prop: 'fill' });
      }

      requestAnimationFrame(() => {
        elements.forEach(({ el, prop }) => {
          el.style.transition = SYNC_TRANSITION;
          el.style[prop] = color;
        });
      });
    }

    updateMenuPositions() {
      const total = this.navButtons.length;
      this.navButtons.forEach((btn, index) => {
        btn.classList.remove(CLASSES.active, CLASSES.prev, CLASSES.next, CLASSES.hidden);
        btn.style.left = '';
        const prevIndex = (this.currentMenuIndex - 1 + total) % total;
        const nextIndex = (this.currentMenuIndex + 1) % total;
        if (index === this.currentMenuIndex) btn.classList.add(CLASSES.active);
        else if (index === prevIndex) btn.classList.add(CLASSES.prev);
        else if (index === nextIndex) btn.classList.add(CLASSES.next);
        else {
          btn.classList.add(CLASSES.hidden);
          const dist = (index - this.currentMenuIndex + total) % total;
          btn.style.left = dist > total / 2 ? '-20%' : '120%';
        }
      });
    }

    navigate(direction) {
      if (this.visibleSlides.length === 0) return;
      const total = this.visibleSlides.length;
      this.currentIndex = direction === 'next'
        ? (this.currentIndex + 1) % total
        : (this.currentIndex - 1 + total) % total;
      this.updateSlides();
    }

    handleSlideClick(slide, event) {
      const index = this.visibleSlides.indexOf(slide);
      if (index === -1 || index === this.currentIndex) return;
      if (event.target.closest('a, button')) return;
      const total = this.visibleSlides.length;
      const nextIndex = (this.currentIndex + 1) % total;
      const prevIndex = (this.currentIndex - 1 + total) % total;
      if (index === nextIndex) this.navigate('next');
      else if (index === prevIndex) this.navigate('prev');
    }

    triggerJellyAnimation() {
      if (!this.pill) return;
      this.pill.classList.remove(CLASSES.animating);
      void this.pill.offsetWidth;
      this.pill.classList.add(CLASSES.animating);
    }

    // =========================================================
    // ADD TO CART (HEHKU NATIVE INTEGRATION)
    // =========================================================
    async handleAddToCart(e, btn) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId) {
        const href = btn.getAttribute('href');
        if (href) window.location.href = href;
        return;
      }

      btn.classList.add(CLASSES.loading);

      try {
        // 1. Adiciona o produto ao carrinho usando a API do Shopify
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        });

        if (!response.ok) throw new Error('Erro ao adicionar');
        const newItem = await response.json();

        // 2. GATILHO NATIVO DO HEHKU (A mágica acontece aqui)
        // Dispara o evento que o theme.js/cart.js do Hehku escutam
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            cart: newItem
          }
        }));
        
        // Dispara também o update padrão para garantir a bolinha
        document.dispatchEvent(new CustomEvent('cart:update', { 
          bubbles: true, 
          detail: { cart: newItem } 
        }));

        // Feedback Visual
        const originalText = btn.textContent;
        btn.textContent = '✓ Adicionado!';
        setTimeout(() => { btn.textContent = originalText; }, 2000);

      } catch (error) {
        console.error('Erro:', error);
        btn.textContent = 'Erro';
        setTimeout(() => { btn.textContent = 'Adicionar'; }, 2000);
      } finally {
        btn.classList.remove(CLASSES.loading);
      }
    }

    // =========================================================
    // EVENT BINDING
    // =========================================================
    bindEvents() {
      this.navButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => this.goToCategory(btn.dataset.category, index));
      });
      if (this.arrowPrev) this.arrowPrev.addEventListener('click', () => this.navigate('prev'));
      if (this.arrowNext) this.arrowNext.addEventListener('click', () => this.navigate('next'));
      this.slides.forEach(slide => {
        slide.addEventListener('click', (e) => this.handleSlideClick(slide, e));
      });
      this.slides.forEach(slide => {
        const btn = slide.querySelector(SELECTORS.btn);
        if (btn) btn.addEventListener('click', (e) => this.handleAddToCart(e, btn));
      });
      if (this.nav) {
        let startX = 0;
        this.nav.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.nav.addEventListener('touchend', (e) => {
          const diff = e.changedTouches[0].clientX - startX;
          if (Math.abs(diff) > 30) {
            const newIndex = diff < 0 ? (this.currentMenuIndex + 1) % this.categories.length : (this.currentMenuIndex - 1 + this.categories.length) % this.categories.length;
            this.goToCategory(this.categories[newIndex], newIndex);
          }
        }, { passive: true });
      }
      this.container.addEventListener('touchstart', (e) => this.handleDragStart(e), { passive: true });
      this.container.addEventListener('touchmove', (e) => this.handleDragMove(e), { passive: false });
      this.container.addEventListener('touchend', () => this.handleDragEnd());
      this.container.addEventListener('touchcancel', () => this.handleDragEnd());
      this.container.addEventListener('mousedown', (e) => this.handleDragStart(e));
      document.addEventListener('mousemove', (e) => this.handleDragMove(e));
      document.addEventListener('mouseup', () => this.handleDragEnd());
      if (this.parallaxEnabled) {
        this.section.addEventListener('mousemove', (e) => this.handleParallax(e));
        this.section.addEventListener('mouseleave', () => this.resetParallax());
      }
      document.addEventListener('keydown', (e) => {
        if (!this.isInViewport()) return;
        if (e.key === 'ArrowLeft') this.navigate('prev');
        if (e.key === 'ArrowRight') this.navigate('next');
      });
      document.addEventListener('shopify:section:select', () => {
        if (this.navButtons.length > 0) this.goToCategory(this.navButtons[0].dataset.category, 0);
      });
    }

    isInViewport() {
      const rect = this.section.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }
  }

  function init() {
    document.querySelectorAll(SELECTORS.section).forEach(section => { new Slider3D(section); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();